import { compose, withStateHandlers, withContext } from 'recompose';
import PropTypes from 'prop-types';
import { isNumber } from "lodash";

export default compose(
  withStateHandlers(
    { activeBlock: 1 },
    { 
      activateBlock: ({ activeBlock }) => e => ({
        activeBlock: isNumber(e) ? e : Number(e.target.dataset.index) || 1
      })
    }
  ),
  withContext(
    { activeBlock: PropTypes.number, activateBlock: PropTypes.func },
    ({ activeBlock, activateBlock }) => ({ activeBlock, activateBlock })
  )
);
